/* eslint-disable import/first */
import '@babel/polyfill';
import Vue from 'vue';
import 'Lib/plugins';
import store from '@/store';
import router from '@/router';
import { sync } from 'vuex-router-sync';
import momentTimezone from 'moment-timezone';
import IdleVue from 'idle-vue';
import VueGraphqlModels from 'vue-graphql-models';
import createProvider, { cachePersistor } from 'Lib/vue-apollo';
import 'Lib/registerServiceWorker';
import 'Lib/filters';

import 'quasar-extras/animate';
import 'quasar-extras/material-icons';
import './styles/quasar.styl';
import './styles/flexboxHelpers.styl';
import './styles/app.styl';
import './styles/fonts.styl';

import App from './App';

momentTimezone.tz.setDefault('America/Chicago');
Vue.config.silent = false;
Vue.config.performance = true;

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 28800000,
  events: [
    'mousemove',
    'mousedown',
    'DOMMouseScroll',
    'keypress',
    'mousewheel',
    'touchmove',
    'MSPointerMove',
    'keydown',
    'touchstart',
    'focus'],
  startAtIdle: false,
});


sync(store, router);

Vue.use(VueGraphqlModels, {
  // debug: true,
  cachePersistor,
  dataLoader(path) {
    return import(/* webpackChunkName: "data/[request]" */ `Data/${path}`);
  },
  modelLoader(path) {
    return import(/* webpackChunkName: "models/[request]" */ `Models/${path}`);
  },
  gqlLoader(path) {
    return import(/* webpackChunkName: "gql/[request]" */ `Gql/${path}.graphql`);
  },
});

export default new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
